<script setup>
import HighlightableField from "@/components/projects/HighlightableField/HighlightableField";

defineProps({
  project: {
    type: Object,
    required: true,
  },
  candidate: {
    type: Object,
    required: true,
  },
  publication: {
    type: Object,
    required: true,
  },
  tokensEnabled: {
    type: Boolean,
    default: false,
  },
});

const getDisplayUrl = (url) => {
  if (!url) return "";
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace("www.", "");
  } catch {
    return url;
  }
};
</script>

<template>
  <div class="mb-4 publication-item">
    <div v-if="publication.title">
      <HighlightableField
        :enabled="tokensEnabled"
        :project="project"
        :candidate="candidate"
        :token-text="publication.title"
        token-type="plain"
        :additional-token-types="['plain']"
        :similarity-tokens="[]"
      />
      <span v-if="publication.published" class="date-label">
        ({{ publication.published }})
      </span>
    </div>

    <div v-if="publication.summary" class="publication-description">
      <HighlightableField
        :enabled="tokensEnabled"
        :project="project"
        :candidate="candidate"
        :token-text="publication.summary"
        token-type="plain"
        :additional-token-types="['plain']"
        :similarity-tokens="[]"
      />
    </div>

    <div v-if="publication.url" class="publication-url">
      <a :href="publication.url" target="_blank" rel="noopener noreferrer">
        <span class="material-icons-outlined md-14">link</span>
        {{ getDisplayUrl(publication.url) }}
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.publication-item {
  color: $tf-font-default;

  .date-label {
    color: $tf-font-ghost;
    margin-left: 4px;
  }

  .publication-description {
    color: $tf-font-ghost;
    margin-top: 4px;
    font-size: 14px;
  }

  .publication-url {
    margin-top: 4px;
    font-size: 14px;

    a {
      color: $blue-100;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 4px;

      &:hover {
        text-decoration: underline;
      }

      .material-icons-outlined {
        font-size: 14px;
      }
    }
  }
}
</style>
